import moment from "moment";

import { CareerType, EmploymentTypes } from "src/shared/config";
import { generateId } from "src/shared/utils";

export const careers: CareerType[] = [
  {
    id: "1",
    title: "Software Engineer",
    responsibilities: [
      "Develop and maintain web applications",
      "Collaborate with cross-functional teams",
      "Write clean, efficient, and scalable code",
      "Participate in code reviews",
    ],
    requirements: [
      "Bachelor's degree in Computer Science or related field",
      "Experience with JavaScript, React, and Node.js",
      "Strong problem-solving skills",
      "Familiarity with cloud services (AWS, Azure)",
    ],
    employmentType: EmploymentTypes.FULL_TIME,
    location: "San Francisco, CA",
    deadline: moment().format("DD.MM.YYYY"),
  },
  {
    id: "2",
    title: "Data Scientist",
    responsibilities: [
      "Analyze large datasets to extract insights",
      "Build machine learning models",
      "Communicate findings with stakeholders",
      "Develop data pipelines",
    ],
    requirements: [
      "Master's degree in Data Science or related field",
      "Proficiency in Python, R, and SQL",
      "Experience with machine learning frameworks",
      "Strong statistical analysis skills",
    ],
    employmentType: EmploymentTypes.REMOTE,
    location: "Yerevan",
    deadline: moment().format("DD.MM.YYYY"),
  },
  {
    id: "3",
    title: "Product Manager",
    responsibilities: [
      "Define product vision and strategy",
      "Work with engineering and design teams",
      "Gather and analyze user feedback",
      "Prioritize product features",
    ],
    requirements: [
      "Experience in product management",
      "Strong analytical and communication skills",
      "Understanding of UX/UI principles",
      "Ability to work in agile environments",
    ],
    employmentType: EmploymentTypes.FULL_TIME,
    location: "New York, NY",
    deadline: moment().format("DD.MM.YYYY"),
  },
  {
    id: "4",
    title: "UX Designer",
    responsibilities: [
      "Design intuitive user experiences",
      "Create wireframes and prototypes",
      "Conduct user research and testing",
      "Collaborate with developers and stakeholders",
    ],
    requirements: [
      "Experience in UX/UI design",
      "Proficiency in Figma, Sketch, or Adobe XD",
      "Strong portfolio of past projects",
      "Knowledge of front-end development principles",
    ],
    employmentType: EmploymentTypes.HALF_TIME,
    location: "Seattle, WA",
    deadline: moment().format("DD.MM.YYYY"),
  },
  {
    id: "5",
    title: "Cybersecurity Analyst",
    responsibilities: [
      "Monitor and secure IT systems",
      "Investigate security breaches",
      "Implement security measures",
      "Train employees on cybersecurity best practices",
    ],
    requirements: [
      "Bachelor’s degree in Cybersecurity or related field",
      "Experience with SIEM tools",
      "Knowledge of network security",
      "Certifications (CISSP, CEH) preferred",
    ],
    employmentType: EmploymentTypes.FULL_TIME,
    location: "Austin, TX",
    deadline: moment().format("DD.MM.YYYY"),
  },
  {
    id: "6",
    title: "Marketing Specialist",
    responsibilities: [
      "Develop and implement marketing campaigns",
      "Analyze marketing metrics",
      "Manage social media presence",
      "Collaborate with sales teams",
    ],
    requirements: [
      "Degree in Marketing, Business, or related field",
      "Experience with digital marketing tools",
      "Strong communication and analytical skills",
      "Creativity and problem-solving mindset",
    ],
    employmentType: EmploymentTypes.CONTACT,
    location: "Los Angeles, CA",
    deadline: moment().format("DD.MM.YYYY"),
  },
  {
    id: "7",
    title: "Sales Representative",
    responsibilities: [
      "Identify and reach out to potential clients",
      "Present products and close deals",
      "Maintain client relationships",
      "Meet sales targets",
    ],
    requirements: [
      "Experience in sales",
      "Excellent communication skills",
      "Ability to negotiate and persuade",
      "Understanding of CRM software",
    ],
    employmentType: EmploymentTypes.FULL_TIME,
    location: "Chicago, IL",
    deadline: moment().format("DD.MM.YYYY"),
  },
  {
    id: "8",
    title: "DevOps Engineer",
    responsibilities: [
      "Manage CI/CD pipelines",
      "Automate infrastructure deployment",
      "Monitor system performance",
      "Enhance security and scalability",
    ],
    requirements: [
      "Experience with Kubernetes and Docker",
      "Knowledge of cloud platforms (AWS, GCP, Azure)",
      "Scripting skills (Bash, Python)",
      "Understanding of networking and security",
    ],
    employmentType: EmploymentTypes.REMOTE,
    location: "Yerevan",
    deadline: moment().format("DD.MM.YYYY"),
  },
  {
    id: "9",
    title: "HR Manager",
    responsibilities: [
      "Manage recruitment and onboarding",
      "Oversee employee relations",
      "Develop HR policies",
      "Conduct performance evaluations",
    ],
    requirements: [
      "Experience in human resources",
      "Strong leadership and organizational skills",
      "Knowledge of labor laws",
      "Excellent communication skills",
    ],
    employmentType: EmploymentTypes.FULL_TIME,
    location: "Boston, MA",
    deadline: moment().format("DD.MM.YYYY"),
  },
  {
    id: "10",
    title: "Technical Writer",
    responsibilities: [
      "Write technical documentation",
      "Simplify complex concepts",
      "Work with developers and engineers",
      "Maintain documentation updates",
    ],
    requirements: [
      "Experience in technical writing",
      "Excellent written communication skills",
      "Familiarity with API documentation",
      "Basic understanding of programming",
    ],
    employmentType: EmploymentTypes.REMOTE,
    location: "Yerevan",
    deadline: moment().format("DD.MM.YYYY"),
  },
];

export const newCareerMock: CareerType = {
  id: generateId(),
  title: "",
  responsibilities: [],
  requirements: [],
  employmentType: EmploymentTypes.FULL_TIME,
  location: "",
  deadline: "",
};

export const initialState: {
  isLoading: boolean;
  error: string;
  careers: CareerType[];
  activeCareerId: CareerType["id"];
  newCareer: CareerType;
} = {
  isLoading: false,
  error: "",
  careers: [],
  activeCareerId: "",
  newCareer: newCareerMock,
};
